const MAX_E2E_REFERENCE_LENGTH = 35;

export {
  MAX_E2E_REFERENCE_LENGTH
}
